<div class="container" [@esvanecerDesvanecer]="'in'">
  <div class="col-sm-12 text-center pt-5">
    <h4><b>Página não encontrada...</b></h4>

    <a href="javascript:history.go(-1)">Voltar</a>
  </div>
</div>
